
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"53","height":"54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.174 25.097h-2.2V13.369l1.875-1.889c.297-.299.396-.736.264-1.135l-2.199-6.648a1.094 1.094 0 00-1.04-.759h-4.397c-.473 0-.891.305-1.045.76l-2.2 6.647c-.131.399-.027.836.265 1.135l1.88 1.89v11.727h-2.2c-.29 0-.571.116-.774.326a1.093 1.093 0 00-.325.782v14.403c0 3.672 2.953 6.647 6.598 6.647s6.597-2.975 6.597-6.648V26.206c0-.294-.115-.576-.324-.781a1.077 1.077 0 00-.775-.327zm-6.922-12.968l-1.716-1.734 1.732-5.24h2.815l1.732 5.24-1.715 1.734a1.093 1.093 0 00-.325.78v12.188h-2.199V12.91c0-.294-.115-.576-.324-.781zm5.822 28.479c0 2.448-1.968 4.431-4.398 4.431-2.43 0-4.399-1.983-4.399-4.431V27.313h8.797v13.295zM38.235 3.82a1.097 1.097 0 00-1.06.06c-.32.205-.512.56-.512.942v5.872h-4.398V4.822c0-.382-.193-.731-.512-.936a1.082 1.082 0 00-1.06-.06 8.827 8.827 0 00-4.966 6.957 8.856 8.856 0 003.239 7.921v23.012c0 3.057 2.463 5.54 5.498 5.54s5.498-2.483 5.498-5.54V18.704a8.86 8.86 0 003.238-7.927 8.827 8.827 0 00-4.965-6.957zm-.005 13.427a1.108 1.108 0 00-.468.909v23.56c0 1.839-1.479 3.323-3.298 3.323-1.82 0-3.3-1.484-3.3-3.323v-23.56c0-.36-.175-.698-.466-.909a6.668 6.668 0 01-2.832-5.445 6.59 6.59 0 012.2-4.936v4.936c0 .294.115.576.318.787.21.205.49.321.78.321h6.598c.292 0 .572-.116.781-.321.204-.21.319-.493.319-.787V6.866a6.59 6.59 0 012.2 4.936 6.668 6.668 0 01-2.832 5.445z","fill":"#88C0B3"}})])
          )
        }
      }
    